<template>
  <div>
    <h1 class="mb-10 text-headline-l" data-testid="speaker-list-heading">{{ t('Speakers.speakers') }}</h1>
    <div class="mb-10 grid grid-cols-1 gap-5 tablet:mb-14 tablet:grid-cols-2">
      <p>
        {{ t('Speakers.speakersInstruction') }}
      </p>
      <div>
        <SpeakerSearch />
      </div>
    </div>
    <div class="my-5">
      <h1 class="mb-4 text-headline-m">{{ t('Speakers.mySpeakers') }}</h1>
      <p class="mb-6">
        {{ t('Speakers.speakersHeader') }}
      </p>
    </div>
    <div class="grid grid-cols-1 gap-8 tablet:grid-cols-2" data-testid="speaker-list-grid">
      <SpeakerListItem v-for="speaker in props.speakers" :key="speaker.id" :speaker="speaker" />
    </div>
    <div v-if="props.pageInfo.totalCount > props.pageInfo.limit" class="flex justify-center">
      <PaginationControl
        class="mt-10"
        :show-per-page-options="false"
        :current-page="props.pageInfo.currentPage"
        :per-page="props.pageInfo.limit"
        :total="props.pageInfo.totalCount"
        data-testid="speaker-list-pagination"
        @update:current-page="emit('update:page', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PaginationControl } from '@ramp106/omrjs-core-ui'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SpeakersQuery } from '@/gql/myomr'

const { t } = useI18n()

type SpeakersConnection = SpeakersQuery['speakers']

const props = defineProps<{
  pageInfo: SpeakersConnection['pageInfo']
  speakers: SpeakersConnection['nodes']
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'reloadSpeakers'): void
  (e: 'update:page', value: number): void
}>()

onMounted(() => emit('reloadSpeakers'))
</script>
